import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageAnimation } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-animation',
  templateUrl: './message-animation.component.html',
  styleUrls: ['../styles/message-content.scss', './message-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageAnimationComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageAnimation = mess as MessageAnimation;
  }

  messageAnimation?: MessageAnimation;
  messageAnimationSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initAnimation();
  }

  private initAnimation(): void {
    if (!this.messageAnimation) return;

    this.fileReaderService
      .getFilePart(this.messageAnimation?.animation?.animation)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setAnimationSource(filePart));
  }

  private setAnimationSource(filePart?: FilePart): void {
    this.messageAnimationSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
